import { render, staticRenderFns } from "./ChatListUniversal.vue?vue&type=template&id=f3e2429e&scoped=true"
import script from "./ChatListUniversal.vue?vue&type=script&lang=js"
export * from "./ChatListUniversal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3e2429e",
  null
  
)

export default component.exports